import React, { useState } from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import { CustomerService } from "../../services";
import { HorizontalCard } from "../../components/Card";
import Vegetarian from "../../assets/vegetarian.svg";
import Disposable from "../../assets/disposable.svg";
import Normal from "../../assets/normal.svg";
import { useFormInput } from "../../shared/utils/CustomHooks";
import { JumpBtn } from "../../components/Buttons";
import { Menu } from "../../models";
import { Actions } from "../../app-state/actions";
import { ApplicationType } from "../../shared/Constants";
import { env } from "../../env";
const isPwa = env.REACT_APP_APPLICATION_TYPE === ApplicationType.PWA;

const StyledContainer = styled.div`
    width: 40vw;
    margin: auto;
    display: flex;
    justify-content: space-around;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;

    @media (max-width: 1000px) {
        width: 100vw;
        padding-top: 6svw;
    }
`;

interface IStep {
    isActive?: boolean;
}
const Step = styled.li<IStep>`
    list-style: none;
    display: inline-block;
    width: 30.33%;
    position: relative;
    text-align: center;
    cursor: pointer;

    color: ${(props) => (props.isActive ? "green" : "grey")};

    &:before {
        content: counter(step);
        counter-increment: step;
        width: 30px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #ddd;
        border-radius: 100%;
        display: block;
        text-align: center;
        margin: 0 auto 10px auto;
        background-color: #fff;

        border-color: ${(props) => (props.isActive ? "green" : "grey")};
    }

    &:after {
        content: "";
        position: absolute;
        width: 100%;
        height: 1px;
        background-color: #ddd;
        top: 15px;
        left: -50%;
        z-index: -1;

        background-color: ${(props) => (props.isActive ? "green" : "grey")};
    }

    &:first-child:after {
        content: none;
    }
`;

const ProgressBar = styled.ul`
    counter-reset: step;
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 0;
`;

const resolveImg = (key: string): string => {
    switch (key.toLowerCase()) {
        case "disposable":
        case "disposable_normal":
        case "disposable_vegetarian":
            return Disposable;
        case "normal":
            return Normal;
        case "vegetarian":
            return Vegetarian;
        default:
            return Normal;
    }
};

interface IRenderOptios {
    menu: Menu;
    customerId?: number;
    isDelivery?: boolean;
    orderMessage?: string;
}
const RenderOptions: React.FC<IRenderOptios> = ({
    menu,
    customerId,
    isDelivery,
    orderMessage,
}) => {
    const dispatch = useDispatch();

    const createOrder = async (menuType: string) => {
        const sr = await CustomerService.CreateOrder({
            menuID: menu.menuID,
            menuTypeCode: menuType,
            createdFrom: isPwa ? ApplicationType.PWA : ApplicationType.TOTEM,
            customerId: customerId,
            isDelivery: isDelivery,
            deliveryMessage: orderMessage,
        });

        if (sr.status()) {
            dispatch(Actions.ADD_ORDER(sr.data));
        } else {
            dispatch(
                Actions.ADD_ORDER({
                    menuID: 0,
                    menuTypeCode: "",
                    createdFrom: "",
                    isError: true,
                    orderMessageAlert: sr.getParsedError(),
                })
            );
        }
    };

    return (
        <>
            {menu.menuTypes.map((type, index) => (
                <HorizontalCard
                    key={index}
                    srcImg={resolveImg(type.code)}
                    title={type.description}
                    onClick={() => createOrder(type.code)}
                />
            ))}
        </>
    );
};

interface IDeliveryButtons {
    toDelivery: React.Dispatch<React.SetStateAction<boolean>>;
    toNextStep: () => void;
}
const DeliveryButtons: React.FC<IDeliveryButtons> = (props) => {
    return (
        <div style={{ margin: 12 }}>
            <JumpBtn
        		borderColor={"#0053a0"}
                colorOnHover={"#0053a0"}
                value="Envío a Piso"
                onClick={() => props.toDelivery(true)}
            />
            <JumpBtn
                borderColor={"#ef3c34"}
                colorOnHover={"#ef3c34"}
                value="En Comedor"
                onClick={() => props.toNextStep()}
            />
        </div>
    );
};

const RenderAllowDelivery = (menu: Menu, customerId?: number) => {
    const [step, setStep] = useState<number>(1);
    const [isDelivery, setIsDelivery] = useState<boolean>(false);
    const input = useFormInput("");

    const handleClickStep = () => {
        if (input.value && !(input.value.length < 10)) {
            setStep(2);
        } else if (isDelivery) {
            toast.error("Debe completar con datos, al menos 10 caracteres");
        }
    };

    const isNotDelivery = () => {
        setStep(2);
    };

    return (
        <>
            <ProgressBar>
                <Step isActive>Instrucciones de entrega</Step>
                <Step
                    isActive={step === 2}
                    onClick={() => {
                        handleClickStep();
                    }}
                >
                    Seleccion de Menú
                </Step>
            </ProgressBar>
            {step === 1 ? (
                isDelivery ? (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                        <textarea
                            id="w3review"
                            name="w3review"
                            rows={4}
                            cols={45}
                            style={{ marginBottom: "1vw" }}
                            maxLength={100}
                            {...input}
                            placeholder="Ingrese lugar y horario de entrega"
                        ></textarea>
                        <div style={{ display: "inline-flex" }}>
                            <JumpBtn
                                borderColor={"green"}
                                colorOnHover={"green"}
                                value="Continuar"
                                onClick={handleClickStep}
                            />
                        </div>
                    </div>
                ) : (
                    <DeliveryButtons
                        toDelivery={setIsDelivery}
                        toNextStep={isNotDelivery}
                    />
                )
            ) : (
                <RenderOptions
                    menu={menu}
                    customerId={customerId}
                    isDelivery={isDelivery}
                    orderMessage={input.value}
                />
                //RenderOptions(menu, customerId, isDelivery, input.value)
            )}
        </>
    );
};

interface ISelectionMenu {
    allowDelivery?: boolean;
    customerId?: number;
    menu: Menu;
}

const SelectionMenu: React.FC<ISelectionMenu> = ({
    allowDelivery,
    menu,
    customerId,
}) => {
    return (
        <StyledContainer>
            {allowDelivery ? (
                RenderAllowDelivery(menu, customerId)
            ) : (
                <RenderOptions menu={menu} customerId={customerId} />
            )}
        </StyledContainer>
    );
};

export default SelectionMenu;
